<template>
  <el-dialog
    title="点位类型"
    :visible.sync="dialogVisible"
    width="480px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form :model="formInline" ref="form" :rules="rules">
        <el-form-item label="点位类型名称" prop="typeName">
          <el-input
            v-model="formInline.typeName"
            placeholder="请输入点位类型名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="enableStatus">
          <el-switch
            v-model="formInline.enableStatus"
            :active-value="0"
            :inactive-value="1"
            active-color="#0495FF"
          >
          </el-switch>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="addOrUpdateFun">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { addPointType, updatePointType } from "@/api/point.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      formInline: {
        typeName: "",
        enableStatus: 0,
        id: ""
      },
      rules: {
        typeName: [
          { required: true, message: "请输入点位类型", trigger: "blur" }
        ],
        enableStatus: [
          { required: true, message: "请选择是否启用", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    if (this.curItem && this.curItem.id)
      this.formInline = JSON.parse(JSON.stringify(this.curItem));
  },
  methods: {
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async addOrUpdateFun() {
      let xx = true;
      this.$refs["form"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      let params = {
        typeName: this.formInline.typeName,
        enableStatus: this.formInline.enableStatus,
        id: this.formInline.id
      };
      let res = null;
      if (this.curItem.id) {
        res = await updatePointType(params);
      } else {
        res = await addPointType(params);
      }

      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

/deep/.el-input {
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/point/pointType/components/addDialog.vue